/*eslint-disable*/
import React, { useEffect, useRef, useState } from 'react';
import { Button, Form } from 'react-bootstrap';

import { api_gateway } from '../../../conexoes/api';
import { setaDropdown } from '../../../utils/alternanciaIcones';
import SpinerVeye from '../../spinnerVeye/spinnerVeye.js';
export default function SelectMultiPais(props) {
    const [spinAtivo, setSpinAtivo] = useState(true);
    const [lsPais, setLsPais] = useState([])
    const modal = useRef();
    let todosUsuarios = []

    const handleClickFora = e => {
        if (!modal.current.contains(e.target)) {
            handleCancelar()
        }
    };

    function handlePais(codigo, checkbox){
        if(codigo == -1){
            handleSelecionarTodos(checkbox)
        }
        else{
            if(checkbox === true){
                props.arrayPais.push(codigo)
            }else{
                props.arrayPais.forEach(function(e, index){
                    if(codigo == e){
                        props.arrayPais.splice(index, 1);
                    }
                })
            }
        }
        
    }

    function handleSelecionarTodos(checked){
        const length = props.arrayPais.length
        let i =0
        while(i < length){
            props.arrayPais.pop()
            i++
        }
  
        if(checked === true){
            todosUsuarios.forEach(function(pais){
                props.arrayPais.push({'cd_pav_pais' : pais.cd_pav_pais})
        })
       }

    }

    function handleCancelar(){
        props.setRevelarSelectMultiPais(false)
    }

    useEffect(() => {
        setSpinAtivo(true)
        async function renderPais(){
            const {data} = await api_gateway.get('/m1/consultar/pais');
            data.dados.unshift({"cd_pav_pais":-1,"ds_pav_pais":"Todos"})
            todosUsuarios=data.dados
            
            if(data.dados.length > 0){
                let objetoPais = data.dados.map((item,i) => {
                    return (
                        <li key={"menu-"+item.cd_pav_pais}>
                            <div className="campo-select-opcao-checkbox campo-select-opcao-2 campo-select-opcao-automacao">
                                <label className="container-checkbox-item-select">
                                    <input id={item.cd_pav_pais} type="checkbox" defaultChecked={handleMarcarCheckboxes(item.cd_pav_pais) ? true : false} onChange={e => handlePais(item.cd_pav_pais, e.target.checked)}/>
                                    <span className="chekmark-checkbox-item-select" />
                                </label>
                                <span className="fonte-cor-1 nao-selecionavel">{item.ds_pav_pais}</span>
                            </div>
                            {data.dados[i+1]!=undefined&&<div className="campo-select-divisor-cor-1 campo-select-divisor" />}
                        </li>
                    );
                })
                setLsPais(objetoPais)
            }else{
                let objetoPais = () => {
                    return (
                        <li>
                            <div disabled className="campo-select-opcao campo-select-opcao-1">
                                <span className="fonte-cor-1 fonte-campo campo-select-opcao-label nao-selecionavel">Nenhuma informação encontrada</span>
                            </div>
                        </li>
                    );
                }
                setLsPais(objetoPais)
            }
            setSpinAtivo(false)
        }
        renderPais()
        document.addEventListener('mousedown', handleClickFora);
        return () => document.removeEventListener('mousedown', handleClickFora);
    }, [])

    function handleMarcarCheckboxes(codigo){
        let verificacao = false
        props.arrayPais.forEach(function(e){

            if(codigo == e){

                verificacao = true
            }
        })
        return verificacao
    }

    return(
        <Form ref={modal}>
            { spinAtivo && <div className="componente-spinner-overlay"><div className="componente-spinner-container"><SpinerVeye/></div></div> }  
            <Button name="cdTipoPessoa" className="campo-texto-cor-3 campo-select campo-select-absoluto" onClick={() => handleCancelar()}>
                <div className="fonte-cor-1 label-campo">{props.dsPais}</div>
                <img className="campo-select-icone-ativado" src={setaDropdown()} alt="drop" />
            </Button>
            <div className="campo-select-triangulo-cor-1 campo-select-triangulo triangulo-select-absoluto" />
            <div className="campo-texto-cor-3 campo-select-usuarios-checkbox-corpo">
                <ul className="campo-select-lista">
                    {lsPais}
                </ul>
            </div>
        </Form>
    )
}